import { CheckOutlined, CopyOutlined } from '@ant-design/icons';

import * as S from './CopyableCode.styled';

export interface CopyableCodeProps {
  value: string;
  className?: string;
  fallback?: string;
}

export default function CopyableCode({
  value,
  className,
  fallback = 'N/A',
}: CopyableCodeProps) {
  const displayValue = value || fallback;
  const hasValue = Boolean(value);

  return (
    <S.StyledText
      className={className}

      copyable={
        hasValue
          ? {
            text: value,
            tooltips: ['Copiar', 'Copiado!'],
            icon: [<CopyOutlined />, <CheckOutlined />],
          }
          : false
      }
    >
      {displayValue}
    </S.StyledText>
  );
}
